/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_TitleInputs */

const en_pc_rv_title = /** @type {(inputs: Pc_Rv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it is like to use`)
};

const zh_pc_rv_title = /** @type {(inputs: Pc_Rv_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实际用起来怎么样`)
};

/**
* | output |
* | --- |
* | "What it is like to use" |
*
* @param {Pc_Rv_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_title = /** @type {((inputs?: Pc_Rv_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_title(inputs)
	return zh_pc_rv_title(inputs)
});
export { pc_rv_title as "pc.rv.title" }